// extracted by mini-css-extract-plugin
module.exports = {"overview_container":"DashboardOverview_overview_container__39Z3q"};